import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import { useRef } from 'react';
import emailjs from 'emailjs-com'
import { useState } from 'react';
const Contact = () => {
  const form = useRef();
  const [message,setmessage]=useState("Message Sent")
  const [isAlertVisible,setisAlertVisible]=useState(false)
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_regeozw', 'template_57tv985', form.current, 'q34N5hf6J8k0OQZ3J')
      .then((result) => {
          console.log(result.text);
          setisAlertVisible(true)
          setTimeout(()=>{
            setisAlertVisible(false);
          },3000);
      }, (error) => {
          console.log(error.text);
          setisAlertVisible(true)
          setmessage("Error in sending the message")
      });

      e.target.reset()
  };
  return (
    <section id='contact'>
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact__container'>
        <div className='contact__options'>
          <article className='contact__option'>
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>anmol.sharma230796@gmail.com</h5>
            <a href="mailto:anmol.sharma230796@gmail.com" target='_blank'>Send a Message</a>

          </article>




        </div>
        {/*End of Contact Options*/}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Yor Full Name' required/>
          <input type="email" name='email' placeholder='Your Email' required/>
          <textarea name='message' rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary' >Send Message</button>
        </form>
        {isAlertVisible &&
        <span>{message}</span>}
      </div>
    </section>
  )
}

export default Contact